export function PolicyLayout({ title, updated, children, testId }) {
  return (
    <div data-testid={testId} className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="font-display text-display-md uppercase text-foreground mb-2">{title}</h1>
      <p className="font-body text-xs text-textSecondary mb-10">Last updated: {updated}</p>
      <div className="font-body text-sm md:text-base text-foreground/90 space-y-5 leading-relaxed [&_h2]:font-subtitle [&_h2]:text-lg [&_h2]:uppercase [&_h2]:tracking-wide [&_h2]:text-foreground [&_h2]:pt-4">
        {children}
      </div>
    </div>
  );
}
